module.exports = "/_next/static/images/paypal-ca0f51d617947f9bd23e7e0fd8d0475e.svg";